import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useVersionList = () => {
  const [loading, setLoading] = useState(true);
  const [versionList, setVersionList] = useState([]);
  const [pageRef, setPageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getVersionList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get('SettingSystem/Application/VersionControl/List', { params })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);

          setVersionList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.guid,
              version: element.version,
              dateTime: element.dateTime,
              isForced: element.isForced,
              fileUrl: element.fileUrl,
            }));

            return { ...prev, [params?.Page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getVersionList, loading, versionList, pageRef];
};

export default useVersionList;
